<script>
import { PolarArea, mixins } from 'vue-chartjs';
import chartMixins from '../../../mixins/charts';

const { reactiveProp } = mixins;

export default PolarArea.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    this.addPlugin(chartMixins.plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  },
});
</script>



// WEBPACK FOOTER //
// AnalyticsPolarAreaChart.vue?57e3c650